import type { FC } from 'react';

import type { TIconProps } from './icon.props';

const IconLock: FC<TIconProps> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M10.6667 7.33333H5.33333C4.59695 7.33333 4 7.93029 4 8.66667V12C4 12.7364 4.59695 13.3333 5.33333 13.3333H10.6667C11.403 13.3333 12 12.7364 12 12V8.66667C12 7.93029 11.403 7.33333 10.6667 7.33333Z"
    />
    <path
      d="M6 7.33333V5.33333C6 4.8029 6.21071 4.29419 6.58579 3.91912C6.96086 3.54405 7.46957 3.33333 8 3.33333C8.53043 3.33333 9.03914 3.54405 9.41421 3.91912C9.78929 4.29419 10 4.8029 10 5.33333V7.33333"
    />
  </svg>
);

export {
  IconLock,
};
